import { render, staticRenderFns } from "./FormInvestimento.vue?vue&type=template&id=665f71cc&"
import script from "./FormInvestimento.vue?vue&type=script&lang=js&"
export * from "./FormInvestimento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports